module.exports = __webpack_public_path__ + "files/e615647c3eabab64f3594efb43d30ecb.png";